import React, { Component, Fragment } from 'react';
import theme from '../../muiTheme';
import Alert from '@material-ui/lab/Alert';
import CircularProgress from 'material-ui/CircularProgress';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

class UnitValidator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUnitIdWarning: false,
      isQueryingUnitId: false,
      unitIdIsValid: false,
      unitIdString:'',
      alertIsOpen: false
    };
  }

  verifyUnitId = () =>
  {
    this.setState({
        isQueryingUnitId: true,
        showUnitIdWarning: false
    });

    window.api.getUnitId(this.props.unit).then(unitIdResponse => {
       const unitIdIsValid = (unitIdResponse && unitIdResponse.units && unitIdResponse.units.length > 0);
       const unitIdString = (unitIdIsValid) ? "Valid" : "Invalid";

       if (unitIdIsValid)
       {
          this.props.onValidated(unitIdResponse.units[0].AGENCY);
       }

       this.setState({
           isQueryingUnitId: false,
           showUnitIdWarning: true,
           unitIdIsValid: unitIdIsValid,
           unitIdString: unitIdString,
           alertIsOpen: true
       });
    });
  }

  getUnitIdAlert = () =>
  {
    if (this.state.showUnitIdWarning)
    {
      return (
        <Collapse in={this.state.alertIsOpen}>
          <Alert action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => {
                  this.setState({
                      alertIsOpen: false
                  });
                }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={(this.state.unitIdIsValid) ? "success" : "warning"}>{this.state.unitIdString}</Alert></Collapse>);
    }

    return (this.state.isQueryingUnitId) ? (<CircularProgress size={18} thickness={3} color={theme.palette.primary1Color} />) : "";
  }

  render()
  {
    const alert= this.getUnitIdAlert();

    return (
      <Fragment>
       <Button size="small" onClick={this.verifyUnitId} color="primary">Validate</Button>
      {alert}
      </Fragment>
    );
  }
}

export default UnitValidator;
